export default __webpack_public_path__ + "static/media/logo_gold.1845d9db.webp";